/**
 * Replace Craft “asset / entry url” ref-tags with the fallback URL.
 *
 *   {asset:264552:url||https://…/image.png}     →  https://…/image.png
 *   {entry:123@1:url||https://…/page.pdf}      →  https://…/page.pdf
 *
 * Variable tokens like {entry:123:plainText} are NOT touched.
 */
export default function stripUrlReferenceTags(html = "") {
  if (typeof html !== "string" || !html.includes("{")) return html;

  return (
    html
      // asset:url tag
      .replace(
        /\{asset:\d+(?:@[^\:]+)?:url\|\|([^}]+)}/gi,
        (_, fallback) => fallback
      )
      // entry:url tag (non-variable variant)
      .replace(
        /\{entry:\d+(?:@[^\:]+)?:url\|\|([^}]+)}/gi,
        (_, fallback) => fallback
      )
  );
}
